/**
 * True when the current document is loaded inside the same-origin translator
 * editor iframe (`/translate/*` parent). Pages should consult this from any
 * "auto-redirect on mount" effect and skip the redirect so translators can see
 * the page UI — the navigation guard alone can't fully prevent App Router's
 * RSC-fetch + Suspense swap, which can change visible content before the URL
 * change is intercepted.
 *
 * The `TranslateNavigationGuardScript` (rendered into `<body>` with
 * `strategy="beforeInteractive"`) sets `window.__martiniInTranslator = true`
 * during HTML parse, so this is safe to call from a useEffect.
 */
declare global {
  interface Window {
    __martiniInTranslator?: boolean
  }
}

export function isInTranslatorIframe(): boolean {
  if (typeof window === 'undefined') return false
  if (window.__martiniInTranslator === true) return true
  try {
    if (window.parent === window) return false
    if (window.parent.origin !== window.location.origin) return false
    return window.parent.location.pathname.startsWith('/translate/')
  } catch {
    return false
  }
}
